import { AgGridReact } from "ag-grid-react";
import React, { useState, useEffect, useRef } from "react";
import actionButtonRenderer from "../renderer/actionButtonRenderer";
import "./ListQuery.css";
import { useLocation, useNavigate } from "react-router-dom";
import QueryPreview from "./Querypreview";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import SubHeader, {
  SubHeaderLeft,
  SubHeaderRight,
} from "../../../layout/SubHeader/SubHeader";
import Icon from "../../../components/icon/Icon";
import Input from "../../../components/bootstrap/forms/Input";
import Dropdown, {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "../../../components/bootstrap/Dropdown";
import Page from "../../../layout/Page/Page";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as DeleteSvg } from "../../../components/icon/delete.svg";
import { ReactComponent as EditSvg } from "../../../components/icon/edit.svg";
import { ReactComponent as SearchSvg } from "../../../components/icon/search.svg";
import Button from "../../../components/bootstrap/Button";
import Popovers from "../../../components/bootstrap/Popovers";
import Card, { CardBody } from "../../../components/bootstrap/Card";
import IconButton from "@mui/material/IconButton";
import { InputAdornment, Menu, MenuItem, TextField } from "@mui/material";
import { FilterStack } from "../../../components/icon/svg-icons";
import SearchInput from "../../../components/SearchInput";
import FilterMenu from "../../../components/FilterMenu";
import DeletePrompt from "../common-component/DeletePrompt";
import ToastComponent, {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
interface QueryDetail {
  id: number;
  name: string;
}

interface QueryListProps {
  type: "add" | "delete";
  detail: QueryDetail[];
  newId: number;
}

interface ListQueryV2Props {
  queryList: QueryListProps;
  setQueryList: React.Dispatch<React.SetStateAction<QueryListProps>>;
}

const ListQuery: React.FC<ListQueryV2Props> = ({ queryList, setQueryList }) => {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const [rows, setRows] = React.useState<any[]>([{}]);
  const [duplicateRows, setDuplicateRows] = React.useState<any[]>([{}]);
  const [rowHeight, setRowHeight] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = React.useState<string>("name");
  const [queryData, setQueryData] = React.useState<any>();
  const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
  const [searchedString, setSearchedString] = React.useState("");
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [filterValue, setFilterValue] = useState<string>("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [data, setData] = React.useState<any>();
  const [openPreviewDeleteDialog, setOpenPreviewDeleteDialog] =
    React.useState(false);
  const hasRun = useRef(false); // Ensures edit() is called only once
  const token = localStorage.getItem("token");

  const [rowDataToBeDeleted, setRowDataToBeDeleted] = React.useState<any>();
  const [gridApi, setGridApi] = useState<any>(null);
  const getRowStyle = (params: any) => {
    if (params.node.rowIndex % 2 !== 0) {
      return { background: "#F5F7F8", height: "10px" };
    } else {
      return { background: "#FCFCFC", height: "10px" };
    }
  };
  const location = useLocation();
  const navigate = useNavigate();

  const Buttons: (params: any) => React.JSX.Element = (
    params: any
  ): React.JSX.Element => (
    <div className="items-justify-center justify-center w-fit">
      <IconButton
        // className="w-10"
        onClick={() => edit(params)}
      >
        <EditSvg />
      </IconButton>
      <> </>
      <IconButton onClick={() => handleDelete(params)}>
        <DeleteSvg className="" />
      </IconButton>

      <> </>
      <Button
        className="h-9 bg-pink-400 preview-bttn"
        // variant="contained"
        onClick={() => handlePreviewOpen(params)}
      >
        Preview
      </Button>
    </div>
  );

  const calculateRowHeight = () => {
    const vh = window.innerHeight / 100;
    return 6 * vh;
  };

  React.useEffect(() => {
    if (
      location.state?.redirectToEdit &&
      location.state.queryData &&
      !hasRun.current
    ) {
      hasRun.current = true;
      edit({ data: location.state.queryData });

      // Replace the state so it doesn't trigger again
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    const updateRowHeight = () => setRowHeight(calculateRowHeight());
    updateRowHeight();
    window.addEventListener("resize", updateRowHeight);

    return () => window.removeEventListener("resize", updateRowHeight);
  }, []);
  function deleteQueryOnConfirmation(data: any) {
    deleteQuery(data);
  }
  const deleteQuery = async (params: any) => {
    try {
      var id = params.data.id;
      const token = localStorage.getItem("token");
      const response = await fetch(`${vyu_api_url}/query/delete?id=${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setData(data);
      handleSuccess(data.message);
      setRows((prevRows) => {
        const updatedRows = prevRows.filter((item) => item.id !== Number(id));
        // console.log(updatedRows);
        return updatedRows;
      });
    } catch (e) {
      console.log("error occured ", e);
    }
  };
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  function handleDelete(data: any) {
    setOpenPreviewDeleteDialog(true);
    setRowDataToBeDeleted(data);
  }
  function edit(params: any) {
    let queryDetail: QueryDetail = {
      id: params.data.id,
      name: params.data.name || "",
    };
    const isPresent = queryList.detail.some(
      (item: QueryDetail) => item.id === queryDetail.id
    );
    setQueryList({
      type: "add",
      detail: isPresent ? queryList.detail : [...queryList.detail, queryDetail],
      newId: params.data.id,
    });
  }

  function handlePreviewOpen(queryData: any) {
    console.log("queryData in handlePreviewOpen:", queryData.data.id);

    setOpenPreviewDialog(true);
    setQueryData(queryData.data.id);
  }

  const [columns, setColumns]: any[] = React.useState<any[]>([
    { field: "id", headerName: "id", filter: "agTextColumnFilter", hide: true },
    {
      field: "name",
      headerName: "Name",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "dataSource",
      headerName: "Data Source",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "selectString",
      headerName: "Select",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "fromString",
      headerName: "From",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "parentQueryName",
      headerName: "Parent Query",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "whereString",
      headerName: "Where",
      filter: "agTextColumnFilter",
      flex: 25,
      cellClass: "other-column",
    },
    {
      field: "querytype",
      headerName: "Query Type",
      filter: "agTextColumnFilter",
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 15,
      cellRenderer: Buttons,
      cellRendererParams: {
        edit: edit.bind(this),
        handleDelete: handleDelete.bind(this),
        preview: handlePreviewOpen.bind(this),
      },
    },
  ]);

  React.useEffect(() => {
    apiCallToGetAllQueries();
  }, []);

  const apiCallToGetAllQueries = async () => {
    if (gridApi) gridApi.showLoadingOverlay();
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${vyu_api_url}/query/getAllQuery`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "FAILED") {
        handleError(data.message || "Failed to fetch queries");
        return;
      }

      const dataToShow = data?.obj?.map((item: any) => ({
        ...item,
        dataSource: item.datasourceId.name,
        parentQueryName: item.parentQuery?.name,
      }));

      setRows(dataToShow);
      setDuplicateRows(dataToShow);
    } catch (error) {
      console.error("Error fetching queries:", error);
      handleError("Failed to fetch queries. Please try again later.");
      setRows([]);
      setDuplicateRows([]);
    } finally {
      if (gridApi) gridApi.hideOverlay();
    }
  };

  const filters: any = {
    Name: "name",
    Datasource: "datasource",
    Select: "select",
    From: "from",
    Where: "where",
    QueryType: "querytype",
  };

  const handleFilterChange = (e: any) => {
    setSelectedFilter(e);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Remove a specific filter
  const handleRemoveFilter = (filterKey: string) => {
    setSelectedFilters((prev) => prev.filter((item) => item !== filterKey));
  };

  // Function to add/remove filters
  const toggleFilter = (filter: string) => {
    setSelectedFilters(
      (prevFilters) =>
        prevFilters.includes(filter)
          ? prevFilters.filter((f) => f !== filter) // Remove if already selected
          : [...prevFilters, filter] // Add if not selected
    );
  };

  // Function to apply filters to the row data
  // const applyFilters = (value: string) => {
  //   const lowerCaseValue = value.toLowerCase();

  //   const filteredRows = duplicateRows.filter((item) =>
  //     selectedFilters.some((filter) => {
  //       const cellValue = String(item[filter] ?? "").toLowerCase();
  //       return cellValue.includes(lowerCaseValue);
  //     })
  //   );

  //   setRows(filteredRows);
  // };

  // Function to apply filters to the row data
  const applyFilters = async (searchTerm: string) => {
    if (gridApi) gridApi.showLoadingOverlay();
    try {
      // Construct URL with query parameters
      const params = new URLSearchParams({
        query: searchTerm,
        filter: selectedFilters.join(","), // Join filters array as a comma-separated string
      });
      const response = await fetch(
        `${vyu_api_url}/filter/query/searchQueries?${params}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        console.error("Server error:", response.status, response.statusText);
        return;
      }
      const data = await response.json();
      const dataToShow = data.obj.map((item: any) => {
        return {
          ...item,
          dataSource: item.datasourceId.name,
          parentQueryName: item.parentQuery?.name,
        };
      });
      // Check if the response format includes 'obj' and if 'obj' is not empty
      if (data.status === "Success" && data.obj) {
        if (data.obj.length > 0) {
          setRows(dataToShow); // Set rows with the content of 'obj' array
        } else {
          // console.log("No results found.");
          setRows([]); // Set rows to an empty array if 'obj' is empty
        }
      } else {
        setRows([]); // Clear rows if the structure is unexpected
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error,
        `${vyu_api_url}/filter/query/searchQueries`
      );
    } finally {
      if (gridApi) gridApi.hideOverlay();
    }
  };

  // Modified search filter function
  const handleSearchFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterValue(value);
    // If no filters are selected and input is not empty, apply the search value across all columns
    // if (selectedFilters.length === 0 && value !== "") {
    //   const filteredRows = duplicateRows.filter((item) => {
    //     return Object.keys(item).some((key) => {
    //       const itemValue = item[key];
    //       return (
    //         typeof itemValue === "string" &&
    //         itemValue.toLowerCase().includes(value.toLowerCase())
    //       );
    //     });
    //   });
    //   setRows(filteredRows);
    //   return;
    // }
    // If input is empty, apply all selected filters
    if (!value) {
      setRows(duplicateRows);
      return;
    }
    if (value.length >= 2) {
      applyFilters(value);
    } else {
      // Option 1: Reset to original data
      setRows(duplicateRows);
      // Option 2: Do nothing (keep previous results)
      // return;
    }
  };

  return (
    <>
      {/* <Breadcrumb
        list={[
          { title: "Query Tool", to: "" },
          { title: "List", to: "" },
        ]}
      /> */}
      <ToastComponent />
      <div style={{ paddingLeft: "3vh" }}>
        <SearchInput
          filterValue={filterValue}
          onSearchChange={handleSearchFilter}
          selectedFilters={selectedFilters}
        />
        <FilterMenu
          filters={filters}
          selectedFilters={selectedFilters}
          onToggleFilter={toggleFilter}
          onRemoveFilter={handleRemoveFilter}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onOpen={handleClick}
        />
      </div>
      <Card className="grid-div">
        <CardBody>
          <AgGridReact
            className="ag-theme-quartz ag-theme-quartz-listWidget"
            rowData={rows}
            columnDefs={columns}
            pagination={true}
            paginationAutoPageSize={true}
            rowHeight={rowHeight}
            getRowStyle={getRowStyle}
            onGridReady={(params) => setGridApi(params.api)}
          />
        </CardBody>
      </Card>
      <DeletePrompt
        component={"Query"}
        dataToBeDeleted={rowDataToBeDeleted}
        open={openPreviewDeleteDialog}
        onclose={() => setOpenPreviewDeleteDialog(false)}
        confirmCallBack={deleteQueryOnConfirmation}
        data={queryData}
      />
      <QueryPreview
        open={openPreviewDialog}
        onclose={() => setOpenPreviewDialog(false)}
        queryId={queryData}
      />
    </>
  );
};

export default ListQuery;
